import {NgModule} from '@angular/core';
import {RouterModule, Routes, UrlMatchResult, UrlSegment} from '@angular/router';
import {environment} from '../environments/environment';
import {NAVIGATIONS} from './data/navigation/navigation.data';
import {NavigationInterceptor} from './interceptor/navigation/navigation.interceptor';
import {BrandingPageComponent} from './page/landing-layout/branding-page/branding-page.component';
import {ContactUsPageComponent} from './page/landing-layout/contact-us-page/contact-us-page.component';
import {HomePageComponent} from './page/landing-layout/home-page/home-page.component';
import {LandingLayoutComponent} from './page/landing-layout/landing-layout.component';
import {
  CookiePolicyPageComponent
} from './page/landing-layout/policy-pages/cookie-policy-page/cookie-policy-page.component';
import {
  PrivacyPolicyPageComponent
} from './page/landing-layout/policy-pages/privacy-policy-page/privacy-policy-page.component';
import {TermsPageComponent} from './page/landing-layout/policy-pages/terms-page/terms-page.component';
import {ThemeLicensePageComponent} from './page/landing-layout/policy-pages/theme-license-page/theme-license-page.component';
import {ThemePrivacyPageComponent} from './page/landing-layout/policy-pages/theme-privacy-page/theme-privacy-page.component';
import {DockTownPrivacyPageComponent} from './page/landing-layout/policy-pages/dock-town-privacy-page/dock-town-privacy-page.component';
import {TidyDesktopPrivacyPageComponent} from './page/landing-layout/policy-pages/tidy-desktop-privacy-page/tidy-desktop-privacy-page.component';
import {LangmiPageComponent} from './page/landing-layout/langmi-page/langmi-page.component';
import {
  LangmiPrivacyPageComponent
} from './page/landing-layout/policy-pages/langmi-privacy-page/langmi-privacy-page.component';
import {
  LangmiPrivacyLocalizedPageComponent
} from './page/landing-layout/policy-pages/langmi-privacy-localized-page/langmi-privacy-localized-page.component';
import {
  LangmiTermsPageComponent
} from './page/landing-layout/policy-pages/langmi-terms-page/langmi-terms-page.component';
import {
  LangmiTeacherTermsPageComponent
} from './page/landing-layout/policy-pages/langmi-teacher-terms-page/langmi-teacher-terms-page.component';
import {
  MaintenancePageComponent
} from './page/landing-layout/raw-content-pages/maintenance-page/maintenance-page.component';
import {NotFoundPageComponent} from './page/landing-layout/raw-content-pages/not-found-page/not-found-page.component';
import {SitemapPageComponent} from './page/landing-layout/sitemap-page/sitemap-page.component';
import {ColorPageComponent} from './page/landing-layout/tool-pages/color-page/color-page.component';
import {ConverterPageComponent} from './page/landing-layout/tool-pages/converter-page/converter-page.component';
import {PalettePageComponent} from './page/landing-layout/tool-pages/palette-page/palette-page.component';
import {GradientPageComponent} from './page/landing-layout/tool-pages/gradient-page/gradient-page.component';
import {WallpaperPageComponent} from './page/landing-layout/tool-pages/wallpaper-page/wallpaper-page.component';
import {DynamicWallpaperPageComponent} from './page/landing-layout/tool-pages/dynamic-wallpaper-page/dynamic-wallpaper-page.component';
import {CodeImagePageComponent} from './page/landing-layout/tool-pages/code-image-page/code-image-page.component';
import {ContrastPageComponent} from './page/landing-layout/tool-pages/contrast-page/contrast-page.component';
import {CvdPageComponent} from './page/landing-layout/tool-pages/cvd-page/cvd-page.component';
import {ToolsPageComponent} from './page/landing-layout/tool-pages/tools-page/tools-page.component';
import {AiCostPageComponent} from './page/landing-layout/tool-pages/ai-cost-page/ai-cost-page.component';
import {AiPriceWatchPageComponent} from './page/landing-layout/tool-pages/ai-price-watch-page/ai-price-watch-page.component';
import {ChromeColorPickerPageComponent} from './page/landing-layout/tool-pages/chrome-color-picker-page/chrome-color-picker-page.component';
import {JetbrainsColorPickerPageComponent} from './page/landing-layout/tool-pages/jetbrains-color-picker-page/jetbrains-color-picker-page.component';
import {VscodeColorPickerPageComponent} from './page/landing-layout/tool-pages/vscode-color-picker-page/vscode-color-picker-page.component';
import {MacosColorPickerPageComponent} from './page/landing-layout/tool-pages/macos-color-picker-page/macos-color-picker-page.component';
import {MacosTidyDesktopPageComponent} from './page/landing-layout/tool-pages/macos-tidy-desktop-page/macos-tidy-desktop-page.component';
import {MacosDockTownPageComponent} from './page/landing-layout/tool-pages/macos-dock-town-page/macos-dock-town-page.component';
import {MacosAiTokenMeterPageComponent} from './page/landing-layout/tool-pages/macos-ai-token-meter-page/macos-ai-token-meter-page.component';
import {AiTokenMeterPrivacyPageComponent} from './page/landing-layout/policy-pages/ai-token-meter-privacy-page/ai-token-meter-privacy-page.component';
import {AllInOneThemesPageComponent} from './page/landing-layout/tool-pages/all-in-one-themes-page/all-in-one-themes-page.component';
import {PluginsPageComponent} from './page/landing-layout/plugin-pages/plugins-page/plugins-page.component';
import {ToolsLayoutComponent} from './page/landing-layout/tool-pages/tools-layout.component';
import {
  ExternalRedirectPageComponent
} from './page/splash-layout/external-redirect-page/external-redirect-page.component';
import {SplashLayoutComponent} from './page/splash-layout/splash-layout.component';
import {ThemesPageComponent} from './page/landing-layout/themes-page/themes-page.component';
import {PalettesPageComponent} from './page/landing-layout/palettes-page/palettes-page.component';
import {ColorPalettePageComponent} from './page/landing-layout/color-palette-page/color-palette-page.component';
import {ScreenshotsPageComponent} from "./page/landing-layout/screenshots-page/screenshots-page.component";
import {PinterestPageComponent} from "./page/landing-layout/temp-pages/pinterest-page/pinterest-page.component";
import {LinePageComponent} from "./page/landing-layout/temp-pages/line-page/line-page.component";
import {ThemePageComponent} from "./page/landing-layout/theme-page/theme-page.component";
import {BlogListPageComponent} from "./page/landing-layout/blog-pages/blog-list-page/blog-list-page.component";
import {BlogPostPageComponent} from "./page/landing-layout/blog-pages/blog-post-page/blog-post-page.component";
import {CartPageComponent} from "./page/landing-layout/cart-page/cart-page.component";
import {OrderPageComponent} from "./page/landing-layout/order-page/order-page.component";
import {OrderFindPageComponent} from "./page/landing-layout/order-find-page/order-find-page.component";
import {StoreTermsPageComponent} from "./page/landing-layout/policy-pages/store-terms-page/store-terms-page.component";

// A URL matcher for a tool that has an optional trailing value segment (e.g.
// `tools/gradient` and `tools/gradient/<hexes>`). Using ONE route with this
// matcher — instead of two separate `path` routes — means the blank and valued
// URLs share a single Route object, so Angular REUSES the page component across
// the blank→valued redirect rather than destroying and recreating it (which ran
// ngOnInit twice and visibly generated/flashed the page twice).
function optionalValueMatcher( base: string, paramName: string ) {
  return ( segments: UrlSegment[] ): UrlMatchResult | null => {
    if ( segments.length === 1 && segments[ 0 ].path === base ) {
      return { consumed: segments };
    }
    if ( segments.length === 2 && segments[ 0 ].path === base ) {
      return { consumed: segments, posParams: { [ paramName ]: segments[ 1 ] } };
    }
    return null;
  };
}

const routes: Routes = [
  {
    path: '',
    component: LandingLayoutComponent,
    children: [
      {
        path: '',
        component: HomePageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.notFound.url,
        component: NotFoundPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.maintenance.url,
        component: MaintenancePageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.cookiePolicy.url,
        component: CookiePolicyPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.privacyPolicy.url,
        component: PrivacyPolicyPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.terms.url,
        component: TermsPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.langmi.url,
        component: LangmiPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.langmiPrivacy.url,
        component: LangmiPrivacyPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // the same policy in the app's other languages (tr, de, es, ...), linked from each App Store listing
        path: NAVIGATIONS.langmiPrivacy.url + '/:lang',
        component: LangmiPrivacyLocalizedPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.langmiTerms.url,
        component: LangmiTermsPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.langmiTeacherTerms.url,
        component: LangmiTeacherTermsPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.branding.url,
        component: BrandingPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.blog.url,
        component: BlogListPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.blog.url + '/' + ':slug',
        component: BlogPostPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.themes.url,
        component: ThemesPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.palettes.url,
        component: PalettesPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.colorPalette.url,
        component: ColorPalettePageComponent,
        canActivate: [NavigationInterceptor],
      },
      // /theme/* siblings before /theme: paths under it, not products of it.
      {
        path: NAVIGATIONS.themeLicense.url,
        component: ThemeLicensePageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.themePrivacy.url,
        component: ThemePrivacyPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.theme.url,
        component: ThemePageComponent,
        canActivate: [NavigationInterceptor],
      },
      // The capture workbenches (/screenshots, /pinterest, /line) exist only in local builds (owner,
      // 2026-10-22): the pin, LINE and marketplace captures run against the local server, the live
      // site answers 404 for them.
      ...( environment.production ? [] : [
        {
          path: NAVIGATIONS.screenshots.url,
          component: ScreenshotsPageComponent,
          canActivate: [NavigationInterceptor],
        },
        {
          // Private Pinterest-pin gallery. Not linked from nav or sitemap and
          // shipped noindex (see scripts/seo-route-meta.js) - team-only.
          path: NAVIGATIONS.pinterest.url,
          component: PinterestPageComponent,
          canActivate: [NavigationInterceptor],
        },
        {
          // Private LINE-theme asset workbench. Wrapped in the landing layout (top
          // nav + footer) like the Pinterest gallery. Not linked from nav or
          // sitemap and shipped noindex (see scripts/seo-route-meta.js) - team-only.
          // ?only=<key> = one board; ?asset=<type>&only= = a single asset at
          // native px for a 1:1 PNG export.
          path: NAVIGATIONS.line.url,
          component: LinePageComponent,
          canActivate: [NavigationInterceptor],
        },
      ] ),
      {
        path: NAVIGATIONS.contactUs.url,
        component: ContactUsPageComponent,
        canActivate: [NavigationInterceptor],
      },
      // Store: the cart, "find my order" (a fixed path, so it goes before the
      // token route) and the order page (the secret token is the path segment;
      // Stripe's success_url lands here with ?checkout=success).
      {
        path: NAVIGATIONS.cart.url,
        component: CartPageComponent,
        canActivate: [NavigationInterceptor],
      },
      // the cart was /basket until 2026-09-20 (server.js 301s it too)
      {
        path: 'basket',
        redirectTo: NAVIGATIONS.cart.url,
      },
      {
        path: NAVIGATIONS.orderFind.url,
        component: OrderFindPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.order.url + '/' + ':token',
        component: OrderPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.storeTerms.url,
        component: StoreTermsPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.sitemap.url,
        component: SitemapPageComponent,
        canActivate: [NavigationInterceptor],
      },
    ],
  },
  {
    path: NAVIGATIONS.tools.url,
    component: ToolsLayoutComponent,
    children: [
      {
        // Index: the /tools landing page that lists the tools by section.
        path: '',
        component: ToolsPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.color.url,
        component: ColorPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.color.url + '/' + ':color',
        component: ColorPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.palette.url,
        component: PalettePageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        path: NAVIGATIONS.palette.url + '/' + ':palette',
        component: PalettePageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Single route (custom matcher) for both `gradient` and `gradient/:gradient`
        // so the blank→valued redirect reuses the component instead of recreating
        // it — see optionalValueMatcher above.
        matcher: optionalValueMatcher( NAVIGATIONS.gradient.url, 'gradient' ),
        component: GradientPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // `wallpaper` and `wallpaper/:wallpaper` (the hexes), like the gradient tool
        matcher: optionalValueMatcher( NAVIGATIONS.wallpaper.url, 'wallpaper' ),
        component: WallpaperPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // `dynamic-wallpaper` and `dynamic-wallpaper/:wallpaper` (the hexes): the macOS dynamic wallpaper
        matcher: optionalValueMatcher( NAVIGATIONS.dynamicWallpaper.url, 'wallpaper' ),
        component: DynamicWallpaperPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // the code snippet image generator: code in a Codigrate theme, as a PNG
        path: NAVIGATIONS.codeImage.url,
        component: CodeImagePageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // the AI cost calculator (owner 2026-10-19), the first of the AI tools
        path: NAVIGATIONS.aiCostCalculator.url,
        component: AiCostPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // AI Price Watch (owner 2026-10-28): a stock board of AI token prices, a price line per model and Compare Every Model
        path: NAVIGATIONS.aiPriceWatch.url,
        component: AiPriceWatchPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // the contrast checker: WCAG ratio of a text and a background colour, with the closest passing fixes
        path: NAVIGATIONS.contrastChecker.url,
        component: ContrastPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // the colour blindness simulator: any picture through eight colour vision deficiencies
        path: NAVIGATIONS.colorBlindnessSimulator.url,
        component: CvdPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Exact-match converter pages (e.g. /tools/hex-to-rgb); one route + config
        // per direction so each ranks for its own "x to y" query. The optional
        // :value segment carries a specific conversion (549eff / 234-234-101 /
        // 214-100-66) so every converted color is a shareable URL; the matcher
        // keeps the blank and valued URLs on ONE route so the blank→valued
        // in-place start reuses the component instead of recreating it.
        matcher: optionalValueMatcher( 'hex-to-rgb', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-rgb' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'rgb-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'rgb-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-hsl', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-hsl' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hsl-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hsl-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-hsv', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-hsv' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hsv-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hsv-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-hsb', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-hsb' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hsb-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hsb-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-hwb', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-hwb' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hwb-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hwb-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-cmyk', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-cmyk' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'cmyk-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'cmyk-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-oklch', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-oklch' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'oklch-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'oklch-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-oklab', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-oklab' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'oklab-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'oklab-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-cielab', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-cielab' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'cielab-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'cielab-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-cielch', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-cielch' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'cielch-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'cielch-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-cieluv', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-cieluv' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'cieluv-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'cieluv-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-display-p3', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-display-p3' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'display-p3-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'display-p3-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-xyz', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-xyz' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'xyz-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'xyz-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-yxy', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-yxy' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'yxy-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'yxy-to-hex' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hex-to-hunter-lab', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hex-to-hunter-lab' },
        canActivate: [NavigationInterceptor],
      },
      {
        matcher: optionalValueMatcher( 'hunter-lab-to-hex', 'value' ),
        component: ConverterPageComponent,
        data: { converter: 'hunter-lab-to-hex' },
        canActivate: [NavigationInterceptor],
      },
    ]
  },
  {
    path: NAVIGATIONS.plugins.url,
    component: ToolsLayoutComponent,
    children: [
      {
        // Index: the /plugins hub that lists our browser extensions.
        path: '',
        component: PluginsPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Promo landing page for the All In One Themes Chrome extension.
        path: NAVIGATIONS.chromeAllInOneThemes.url,
        component: AllInOneThemesPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Promo landing page for the Color Picker Chrome extension.
        path: NAVIGATIONS.chromeColorPicker.url,
        component: ChromeColorPickerPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Promo landing page for the Color Picker JetBrains plugin.
        path: NAVIGATIONS.jetbrainsColorPicker.url,
        component: JetbrainsColorPickerPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Promo landing page for the Color Picker VS Code extension.
        path: NAVIGATIONS.vscodeColorPicker.url,
        component: VscodeColorPickerPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Promo landing page for the Color Picker macOS app. Doubles as the
        // app's marketing URL in App Store Connect.
        path: NAVIGATIONS.macosColorPicker.url,
        component: MacosColorPickerPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Promo landing page for Tidy Desktop: AI Organizer, the macOS desktop
        // organizer. Doubles as the app's marketing URL in App Store Connect.
        path: NAVIGATIONS.macosTidyDesktop.url,
        component: MacosTidyDesktopPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Tidy Desktop's privacy policy, under its page: /plugins/macos/tidy-desktop/privacy.
        path: NAVIGATIONS.macosTidyDesktop.url + '/privacy',
        component: TidyDesktopPrivacyPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Promo landing page for Dock Town, the menu bar app that shows how the Mac
        // is doing as a small town. Doubles as the app's marketing URL in App Store Connect.
        path: NAVIGATIONS.macosDockTown.url,
        component: MacosDockTownPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Dock Town's privacy policy, under its page: /plugins/macos/dock-town/privacy.
        path: NAVIGATIONS.macosDockTown.url + '/privacy',
        component: DockTownPrivacyPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // AI Token Meter, the menu bar app for the tokens coding agents use and their cost at API
        // prices: the page the AI Cost Calculator points at, and the app's marketing URL.
        path: NAVIGATIONS.macosAiTokenMeter.url,
        component: MacosAiTokenMeterPageComponent,
        canActivate: [NavigationInterceptor],
      },
      {
        // Its privacy policy, under its page: /plugins/macos/ai-token-meter/privacy.
        path: NAVIGATIONS.macosAiTokenMeter.url + '/privacy',
        component: AiTokenMeterPrivacyPageComponent,
        canActivate: [NavigationInterceptor],
      },
    ]
  },
  {
    path: NAVIGATIONS.external.url,
    component: SplashLayoutComponent,
    children: [{path: '', component: ExternalRedirectPageComponent}],
  },
  // Wildcard catch-all. Any URL that matches no route above renders the
  // custom 404 design, wrapped in LandingLayoutComponent for the nav and
  // the footer. Uses `component` (not redirectTo)
  // so the typed URL is preserved and stays consistent with the HTTP 404
  // status server.js already returns for unknown paths. Must stay last.
  {
    path: '**',
    component: LandingLayoutComponent,
    children: [
      {
        path: '',
        component: NotFoundPageComponent,
        canActivate: [NavigationInterceptor],
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
